<template>
  <div>
    <b-row v-if="loadingItem">
      <b-col cols="12">
        <div class="text-center">
          <b-spinner variant="primary" label="Text Centered"></b-spinner>
        </div>
      </b-col>
    </b-row>
    <b-row v-if="!loadingItem">
      <b-col v-if="mode === 'add'" cols="12">
        <b-form-group
          :label="$lang.person_exam"
          label-for="azmoon_execute"
          :label-cols="this.$config.form.labelCol"
        >
          <requiredComponent
            slot="label"
            :label="$lang.person_exam"
            :rules="$v.audience_person_selected.$params"
          />
          <selectAsync
            :options="audience_person_options"
            v-model="$v.audience_person_selected.$model"
            :asyncFind="getPersonCombo"
            label="text"
            id="value"
            :isValid="
              $v.audience_person_selected.$dirty
                ? !$v.audience_person_selected.$error
                : null
            "
            :loading="audience_person_Loading"
          />
          <b-form-invalid-feedback
            :style="{
              display: $v.audience_person_selected.$error ? 'block' : 'none',
            }"
            id="audience_person_selected_feedback"
          >
            {{ $lang.error_required | replace($lang.person_exam) }}
          </b-form-invalid-feedback>
        </b-form-group>
      </b-col>
      <b-col v-if="audience_person_selected" cols="12">
        <b-alert show variant="info" class="mb-0">
          <i class="fas fa-info-circle fa-lg mr-1" />
          <b v-html="examPersonAlert" />
        </b-alert>
        <b-form-group
          :label="$lang.audience_exam"
          label-for="audience_exam"
          :label-cols="this.$config.form.labelCol"
        >
          <requiredComponent
            slot="label"
            :label="$lang.audience_exam"
            :rules="$v.azmoon_execute_selected.$params"
          />
          <selectAsync
            :allowEmpty="true"
            :options="azmoon_execute_options"
            v-model="$v.azmoon_execute_selected.$model"
            :asyncFind="azmoonExecuteCombo"
            label="text"
            id="value"
            :isValid="
              $v.azmoon_execute_selected.$dirty
                ? !$v.azmoon_execute_selected.$error
                : null
            "
            :loading="azmoon_execute_Loading"
          />
          <b-form-invalid-feedback
            :style="{
              display: $v.azmoon_execute_selected.$error ? 'block' : 'none',
            }"
            id="azmoon_execute_selected_feedback"
          >
            {{ $lang.error_required | replace($lang.audience_exam) }}
          </b-form-invalid-feedback>
        </b-form-group>
      </b-col>
      <b-col v-if="audience_person_selected" cols="12">
        <b-form-group
          :label="$lang.survey_azmoon_execute"
          label-for="survey_azmoon_execute"
          :label-cols="this.$config.form.labelCol"
        >
          <selectAsync
            :allowEmpty="true"
            :options="survey_azmoon_execute_options"
            v-model="$v.survey_azmoon_execute_selected.$model"
            :asyncFind="surveyAzmoonExecuteCombo"
            label="text"
            id="value"
            :isValid="
              $v.survey_azmoon_execute_selected.$dirty
                ? !$v.survey_azmoon_execute_selected.$error
                : null
            "
            :loading="survey_azmoon_execute_loading"
          />
        </b-form-group>
      </b-col>
      <b-col cols="12" md="12">
        <b-form-group
          :label="$lang.interviewTime"
          label-for="interviewTime"
          :label-cols="this.$config.form.labelCol"
        >
          <requiredComponent
            slot="label"
            :label="$lang.interviewTime"
            :rules="$v.interviewTime.$params"
          />
          <date-picker
            v-model="$v.interviewTime.$model"
            type="time"
            :state="$v.interviewTime.$dirty ? !$v.interviewTime.$error : null"
            clearable
            :class="
              $v.interviewTime.$dirty
                ? $v.interviewTime.$error
                  ? 'invalid-date'
                  : 'valid-date'
                : null
            "
            format="HH:mm:ss"
            displayFormat="HH:mm:ss"
          >
          </date-picker>
          <b-form-invalid-feedback
            :state="$v.interviewTime.$dirty ? !$v.interviewTime.$error : null"
          >
            <div v-if="!$v.interviewTime.required">
              {{ $lang.error_required | replace($lang.interviewTime) }}
            </div>
          </b-form-invalid-feedback>
        </b-form-group>
      </b-col>

      <b-col cols="12" md="12">
        <b-form-group
          :label="$lang.virtual_interview_url"
          label-for="virtual_interview_url"
          :label-cols="$config.form.labelCol"
        >
          <requiredComponent
            slot="label"
            :label="$lang.virtual_interview_url"
            :rules="$v.virtual_interview_url.$params"
          />
          <b-form-input
            dir="ltr"
            id="virtual_interview_url"
            type="text"
            :autocomplete="$lang.virtual_interview_url"
            v-model="$v.virtual_interview_url.$model"
            :state="
              $v.virtual_interview_url.$dirty
                ? !$v.virtual_interview_url.$error
                : null
            "
            trim
          >
          </b-form-input>
          <b-form-invalid-feedback id="virtual_interview_url-feedback">
            <div
              v-if="
                !$v.virtual_interview_url.required &&
                $v.virtual_interview_url.url
              "
            >
              {{ $lang.error_required | replace($lang.virtual_interview_url) }}
            </div>
            <div v-if="!$v.virtual_interview_url.url">
              {{ $lang.error_url | replace($lang.virtual_interview_url) }}
            </div>
          </b-form-invalid-feedback>
        </b-form-group>
      </b-col>
      <b-col cols="12" class="text-right">
        <b-button variant="success" @click="submit">
          {{ $lang.submitButton }}
          <i class="fa fa-check"></i>
        </b-button>
        <b-button
          type="reset"
          class="ml-2"
          size="md"
          variant="danger"
          @click="closeModal"
        >
          {{ $lang.cancelButton }}
          <i class="fa fa-ban"></i>
        </b-button>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import VuePersianDatetimePicker from "vue-persian-datetime-picker";
import { required, requiredIf, url } from "vuelidate/lib/validators";
import { pathOr } from "ramda";

export default {
  components: { datePicker: VuePersianDatetimePicker },
  validations: {
    audience_person_selected: {
      required: requiredIf((vm) => !!(vm.mode === "add")),
    },
    azmoon_execute_selected: { required },
    survey_azmoon_execute_selected: {},
    virtual_interview_url: { url },
    interviewTime: {},
  },
  props: {
    mode: {
      type: String,
      default: "add", // edit
    },
    item: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      loadingItem: false,

      audience_person_Loading: false,
      audience_person_options: [],
      audience_person_selected: null,

      azmoon_execute_Loading: false,
      azmoon_execute_options: [],
      azmoon_execute_selected: null,

      survey_azmoon_execute_loading: false,
      survey_azmoon_execute_options: [],
      survey_azmoon_execute_selected: null,

      virtual_interview_url: null,
      interviewTime: null,
      parvandehCode: null,
    };
  },
  computed: {
    examPersonAlert() {
      const parentTermCaption = pathOr("", ["term_caption"], this.item);
      const personTermCaption = pathOr(
        "",
        ["term_caption"],
        this.audience_person_selected
      );
      return `فقط آزمون‌های ایجاد شده برای دوره <b class="text-primary">${
        parentTermCaption || personTermCaption
      }</b> در لیست نمایش داده می شود.`;
    },
  },
  watch: {
    audience_person_selected(value) {
      value && this.getDefaultAzmoonServices();
    },
  },
  methods: {
    pathOr,
    submit() {
      this.$v.$touch();
      if (this.$v.$anyError) {
        return;
      }

      const payload = {
        person_kind: 2,
        interview_location_plan_id: pathOr(null, ["id"], this.$route.params),
        parvandeh_code: pathOr(null, ["value"], this.audience_person_selected),
        azmoon_execute_id: pathOr(
          null,
          ["value"],
          this.azmoon_execute_selected
        ),
        survey_azmoon_execute_id: pathOr(
          null,
          ["value"],
          this.survey_azmoon_execute_selected
        ),
        virtual_interview_url: this.virtual_interview_url,
        interview_time: this.interviewTime,
      };

      const {
        interview_location_plan_id,
        person_code,
        person_kind,
        ...editPayload
      } = payload;

      const data =
        this.mode === "edit"
          ? {
              ...editPayload,
            }
          : {
              ...payload,
            };
      this.$emit("submit", data);
    },
    closeModal() {
      this.$emit("closeModal");
    },
    async getPersonCombo(query) {
      if (!query || query.length < 2) {
        return;
      }
      if (query.length > 2) {
        this.interview_master_options = [];
      }

      try {
        this.audience_person_Loading = true;
        const url =
          this.$config.api_url +
          this.$config.interview.interview_person_combo
            .replace("{0}", 2)
            .replace("{1}", query);
        const response = await this.$httpService.get(url);

        this.audience_person_options = response.data.data.map((x) => {
          return {
            text: `${pathOr(
              "",
              ["parvandeh", "parvandeh_number"],
              x
            )} - ${pathOr("", ["person", "name"], x)} ${pathOr(
              "",
              ["person", "family"],
              x
            )} - ${pathOr("", ["person", "national_code"], x)} - ${pathOr(
              "",
              ["term_caption"],
              x
            )}`,
            term_caption: pathOr("", ["term_caption"], x),
            value: pathOr("", ["parvandeh", "code"], x),
          };
        });
      } catch (error) {
        this.$generateError(error);
      } finally {
        this.audience_person_Loading = false;
      }
    },
    async azmoonExecuteCombo(query) {
      if (!query || query.length < 2) {
        return;
      }
      if (query.length > 2) {
        this.azmoon_execute_options = [];
      }
      /* guidance: get all items in first load */
      const q = query === "default" ? null : query;

      const parvandehCode =
        this.parvandehCode ||
        pathOr(null, ["value"], this.audience_person_selected);

      try {
        this.azmoon_execute_Loading = true;
        const url = `${this.$config.api_url}${this.$config.interview.azmoon_execute_combo}?parvandeh_code=${parvandehCode}&search_txt=${q}`;
        const response = await this.$httpService.get(url);
        const data = pathOr([], ["data", "data"], response);
        this.azmoon_execute_options = data.map((x) => {
          return {
            text: `${x.caption} - ${x.id} `,
            value: x.id,
          };
        });
      } catch (error) {
        this.$generateError(error);
      } finally {
        this.azmoon_execute_Loading = false;
      }
    },
    async surveyAzmoonExecuteCombo(query) {
      if (!query || query.length < 2) {
        return;
      }
      if (query.length > 2) {
        this.survey_azmoon_execute_options = [];
      }
      /* guidance: get all items in first load */
      const q = query === "default" ? null : query;

      const parvandehCode =
        this.parvandehCode ||
        pathOr(null, ["value"], this.audience_person_selected);

      try {
        this.survey_azmoon_execute_loading = true;
        const url = `${this.$config.api_url}${this.$config.interview.azmoon_execute_combo}?parvandeh_code=${parvandehCode}&search_txt=${q}`;
        const response = await this.$httpService.get(url);
        const data = pathOr([], ["data", "data"], response);
        this.survey_azmoon_execute_options = data.map((x) => {
          return {
            text: `${x.caption} - ${x.id} `,
            value: x.id,
          };
        });
      } catch (error) {
        this.$generateError(error);
      } finally {
        this.survey_azmoon_execute_loading = false;
      }
    },
    async fetchData() {
      if (this.mode === "edit" && this.item && Object.keys(this.item).length) {
        this.parvandehCode = pathOr(null, ["parvandeh", "code"], this.item);
        this.audience_person_selected = {
          caption: `${this.item.person_object.full_name} ( ${this.item.person_object.national_code} )`,
          id: this.item.code,
        };
        this.virtual_interview_url = this.item.virtual_interview_url;
        this.getDefaultAzmoonServices();
      }
    },
    async getDefaultAzmoonServices() {
      await this.azmoonExecuteCombo("default");
      this.azmoon_execute_selected = this.azmoon_execute_options.find(
        (item) =>
          item.value ===
          pathOr(null, ["azmoon_execute_object", "id"], this.item)
      );
      await this.surveyAzmoonExecuteCombo("default");
      this.survey_azmoon_execute_selected =
        this.survey_azmoon_execute_options.find(
          (item) =>
            item.value ===
            pathOr(null, ["survey_azmoon_execute_object", "id"], this.item)
        );
    },
  },
  created() {
    this.fetchData();
  },
};
</script>
